module.exports = __webpack_public_path__ + "static/img/dewu.fd5a6b02.png";